/* eslint-disable */
// Image import for instrument icons
// Cabled inst svg icons
import thermistorArrayIcon from '../../assets/img/svg-icons/inst-icons/3d-thermistor-array.svg';
import ADCPIcon from '../../assets/img/svg-icons/inst-icons/adcp.svg';
import benthicFluidFlowIcon from '../../assets/img/svg-icons/inst-icons/benthic-fluid-flow.svg';
import bioAcousticSonarIcon from '../../assets/img/svg-icons/inst-icons/bio-acoustic-sonar.svg';
import bottomPresTiltIcon from '../../assets/img/svg-icons/inst-icons/bottom-pressure-tilt.svg';
import broadbandSeismometerIcon from '../../assets/img/svg-icons/inst-icons/broadband-seismometer.svg';
import CO2Icon from '../../assets/img/svg-icons/inst-icons/co2.svg';
import CTDIcon from '../../assets/img/svg-icons/inst-icons/ctd.svg';
import CTDOIcon from '../../assets/img/svg-icons/inst-icons/ctdo.svg';
import currentMeterIcon from '../../assets/img/svg-icons/inst-icons/current-meter.svg';
import digitalHDCameraIcon from '../../assets/img/svg-icons/inst-icons/digital-hd-camera.svg';
import digitalStillCameraIcon from '../../assets/img/svg-icons/inst-icons/digital-still-camera.svg';
import dissolvedOxygenIcon from '../../assets/img/svg-icons/inst-icons/dissolved-oxygen.svg';
import HVFSamplerVentCapIcon from '../../assets/img/svg-icons/inst-icons/fluid-and-dna-sampler.svg';
import fluorometerIcon from '../../assets/img/svg-icons/inst-icons/fluorometer.svg';
import HPIESIcon from '../../assets/img/svg-icons/inst-icons/hpies.svg';
import HVFInSituChemIcon from '../../assets/img/svg-icons/inst-icons/hydrogen-sulfide-ph-temperature.svg';
import BBLFHydrophoneIcon from '../../assets/img/svg-icons/inst-icons/hydrophone.svg';
import massSpectrometerIcon from '../../assets/img/svg-icons/inst-icons/mass-spectrometer.svg';
import nitrateIcon from '../../assets/img/svg-icons/inst-icons/nitrate.svg';
import opticalBackscatterIcon from '../../assets/img/svg-icons/inst-icons/optical-backscatter.svg';
import osmosisWaterSamplerIcon from '../../assets/img/svg-icons/inst-icons/osmo-sampler.svg';
import PARIcon from '../../assets/img/svg-icons/inst-icons/par.svg';
import pHIcon from '../../assets/img/svg-icons/inst-icons/ph.svg';
import PIIcon from '../../assets/img/svg-icons/inst-icons/pi.svg';
import HVFTempResistivityIcon from '../../assets/img/svg-icons/inst-icons/resistivity-temperature-probe.svg';
import seafloorPressureIcon from '../../assets/img/svg-icons/inst-icons/seafloor-pressure.svg';
import shortPeriodSeismometerIcon from '../../assets/img/svg-icons/inst-icons/short-period-seismometer.svg';
import spectralIrradianceIcon from '../../assets/img/svg-icons/inst-icons/spectral-irradiance.svg';
import spectrophotometerIcon from '../../assets/img/svg-icons/inst-icons/spectrophotometer.svg';
import surfaceWaveSpectra from '../../assets/img/svg-icons/inst-icons/surface-wave-spectra.svg';
// Uncabled inst svg icons
import bulkMetInstPackage from '../../assets/img/svg-icons/inst-icons/bulk-met-inst-package.svg';
import directCovarianceFlux from '../../assets/img/svg-icons/inst-icons/direct-covariance-flux.svg';

// Cabled infra svg icons
import anchorIcon from '../../assets/img/svg-icons/infra-icons/anchor.svg';
import bepIcon from '../../assets/img/svg-icons/infra-icons/benthic-experiment-package.svg';
import deepProfilerIcon from '../../assets/img/svg-icons/infra-icons/deep-profiler.svg';
import lowPowerJBoxIcon from '../../assets/img/svg-icons/infra-icons/low-power-jbox.svg';
import lowVoltageNodeIcon from '../../assets/img/svg-icons/infra-icons/low-voltage-node.svg';
import mediumPowerJBoxIcon from '../../assets/img/svg-icons/infra-icons/medium-power-jbox.svg';
import primaryNodeIcon from '../../assets/img/svg-icons/infra-icons/primary-node.svg';
import platform200m from '../../assets/img/svg-icons/infra-icons/200m-platform.svg';
import shallowProfilerIcon from '../../assets/img/svg-icons/infra-icons/shallow-profiler.svg';
// Uncabled infra svg icons
import multiFunctionNode from '../../assets/img/svg-icons/infra-icons/multi-function-node.svg';
import nearSurfaceInstFrame from '../../assets/img/svg-icons/infra-icons/near-surface-inst-frame.svg';
import highPowerSurfaceBuoy from '../../assets/img/svg-icons/infra-icons/inshore-surface-buoy.svg';
import lowPowerSurfaceBuoy from '../../assets/img/svg-icons/infra-icons/offshore-surface-shelf-buoy.svg';
import surfacePiercingProfiler from '../../assets/img/svg-icons/infra-icons/surface-piercing-profiler.svg';

// Colorbars
import standardColorbar from '../../assets/img/map-colorbars/standard-basemap-colorbar.png';
import accessibleColorbar from '../../assets/img/map-colorbars/accessible-basemap-colorbar.png';
import axialBaseAccessibleColorbar from '../../assets/img/map-colorbars/axial-base-accessible-colorbar.png';
import axialBaseColorbar from '../../assets/img/map-colorbars/axial-base-colorbar.png';
import axialCalderaAccessibleColorbar from '../../assets/img/map-colorbars/axial-caldera-accessible-colorbar.png';
import axialCalderaColorbar from '../../assets/img/map-colorbars/axial-caldera-colorbar.png';
import oregonShelfSlopeAccessibleColorbar from '../../assets/img/map-colorbars/or-shelf-slope-accessible-colorbar.png';
import oregonShelfSlopeColorbar from '../../assets/img/map-colorbars/or-shelf-slope-colorbar.png';
import waOffshoreAccessibleColorbar from '../../assets/img/map-colorbars/wa-offshore-accessible-colorbar.png';
import waOffshoreColorbar from '../../assets/img/map-colorbars/wa-offshore-colorbar.png';

// Icons for infrastructures
const infraIcons = {
  'anchor-icon': anchorIcon,
  'benthic-experiment-package': bepIcon,
  'deep-profiler': deepProfilerIcon,
  'low-power-jbox': lowPowerJBoxIcon,
  'medium-power-jbox': mediumPowerJBoxIcon,
  'low-voltage-node': lowVoltageNodeIcon,
  'primary-node': primaryNodeIcon,
  '200m-platform': platform200m,
  'shallow-profiler': shallowProfilerIcon,
  'multi-function-node': multiFunctionNode,
  'near-surface-inst-frame': nearSurfaceInstFrame,
  'offshore-surface-shelf-buoy': highPowerSurfaceBuoy,
  'inshore-surface-buoy': lowPowerSurfaceBuoy,
  'surface-piercing-profiler': surfacePiercingProfiler,
};
// Icons for instruments
const instIcons = {
  '3d-thermistor-array': thermistorArrayIcon,
  'adcp': ADCPIcon,
  'benthic-fluid-flow': benthicFluidFlowIcon,
  'bio-acoustic-sonar': bioAcousticSonarIcon,
  'bottom-pressure-tilt': bottomPresTiltIcon,
  'broadband-seismometer': broadbandSeismometerIcon,
  'co2': CO2Icon,
  'ctd': CTDIcon,
  'ctdo': CTDOIcon,
  'current-meter': currentMeterIcon,
  'digital-hd-camera': digitalHDCameraIcon,
  'digital-still-camera': digitalStillCameraIcon,
  'dissolved-oxygen': dissolvedOxygenIcon,
  'fluid-and-dna-sampler': HVFSamplerVentCapIcon,
  'osmo-sampler': osmosisWaterSamplerIcon,
  'fluorometer': fluorometerIcon,
  'hpies': HPIESIcon,
  'hydrogen-sulfide-ph-temperature': HVFInSituChemIcon,
  'hydrophone': BBLFHydrophoneIcon,
  'mass-spectrometer': massSpectrometerIcon,
  'nitrate': nitrateIcon,
  'optical-backscatter': opticalBackscatterIcon,
  'par': PARIcon,
  'ph': pHIcon,
  'pi': PIIcon,
  'resistivity-temperature-probe': HVFTempResistivityIcon,
  'seafloor-pressure': seafloorPressureIcon,
  'short-period-seismometer': shortPeriodSeismometerIcon,
  'spectral-irradiance': spectralIrradianceIcon,
  'spectrophotometer': spectrophotometerIcon,
  'bulk-met-inst-package': bulkMetInstPackage,
  'direct-covariance-flux': directCovarianceFlux,
  'surface-wave-spectra': surfaceWaveSpectra,
};

const InitialPolygons = {
  type: 'FeatureCollection',
  crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
  features: [
    { type: 'Feature', properties: { site_name: 'Oregon Slope and Hydrate Ridge', wp_page: 50, site_key: 'oregon-slope' }, geometry: { type: 'Polygon', coordinates: [[[-125.482609764021788, 44.584426781604542], [-125.482609764021788, 44.341902386766549], [-124.931667960708637, 44.341902386766549], [-124.931667960708637, 44.584426781604542], [-125.482609764021788, 44.584426781604542]]] } },

    { type: 'Feature', properties: { site_name: 'Axial Seamount', wp_page: 50, site_key: 'axial' }, geometry: { type: 'Polygon', coordinates: [[[-130.035324187283351, 45.987030675089045], [-130.035324187283351, 45.772967075084331], [-129.675236559151386, 45.772967075084331], [-129.675236559151386, 45.987030675089045], [-130.035324187283351, 45.987030675089045]]] } },

    { type: 'Feature', properties: { site_name: 'Mid-Plate', wp_page: 50, site_key: 'mid-plate' }, geometry: { type: 'Polygon', coordinates: [[[-127.110554791598958, 45.638034643897619], [-127.110554791598958, 45.873075356102383], [-127.44632187506771, 45.873075356102383], [-127.44632187506771, 45.638034643897619], [-127.110554791598958, 45.638034643897619]]] } },

    { type: 'Feature', properties: { site_name: 'Oregon Shelf', wp_page: 50, site_key: 'oregon-shelf' }, geometry: { type: 'Polygon', coordinates: [[[-124.63020067842281, 44.814925516114037], [-124.0764062213914, 44.814925516114037], [-124.0764062213914, 44.56784448388597], [-124.63020067842281, 44.56784448388597], [-124.63020067842281, 44.814925516114037]]] } },

    { type: 'Feature', properties: { site_name: 'Washington Inshore, Self and Offshore', wp_page: 50, site_key: 'washington' }, geometry: { type: 'Polygon', coordinates: [[[-124.25228622139144, 47.14646743659754], [-125.1283667511415, 47.14646743659754], [-125.1283667511415, 46.74097044012931], [-124.25228622139144, 46.74097044012931], [-124.25228622139144, 47.14646743659754]]] } },
  ],
};
// -------------------------------------------------------------------------

const ResearchAreaMap = [
  {
    poly_key: 'oregon-slope',
    area_rd: 'southern-hydrate-ridge',
  },
  {
    poly_key: 'oregon-slope',
    area_rd: 'oregon-slope-base',
  },
  {
    poly_key: 'oregon-slope',
    area_rd: 'oregon-offshore',
  },
  {
    poly_key: 'axial',
    area_rd: 'axial-base',
  },
  {
    poly_key: 'axial',
    area_rd: 'axial-caldera',
  },
  {
    poly_key: 'mid-plate',
    area_rd: 'mid-plate',
  },
  {
    poly_key: 'oregon-shelf',
    area_rd: 'oregon-shelf',
  },
];

// -------------------------------------------------------------------------

const InitialLabels = {
  type: 'FeatureCollection',
  crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
  features: [
    { type: 'Feature', properties: { platform_rd: 'PN1B', site_name: 'Oregon Slope, \n Offshore and\n Hydrate Ridge', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-125.20713886236521, 44.46316458418555, -1242.0] } },
    { type: 'Feature', properties: { platform_rd: 'PN1D', site_name: 'Oregon Inshore \nand\n Shelf', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-124.3533034499071, 44.691385000000004, -113.0] } },
    { type: 'Feature', properties: { platform_rd: 'PN3B', site_name: 'Axial\nSeamount', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-129.85528037321737, 45.879998875086685, -113.0] } },
    { type: 'Feature', properties: { platform_rd: 'PN5A', site_name: 'Mid-Plate', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-127.27843833333334, 45.755555, -2850.0] } },
    { type: 'Feature', properties: { platform_rd: 'CE09', site_name: 'Washington Inshore, Shelf, \nand\n Offshore', region: 'CE' }, geometry: { type: 'Point', coordinates: [-124.69032648626647, 46.943718938363425, -2850.0] } },
  ],
};
// -------------------------------------------------------------------------

const SiteLabels = {
  type: 'FeatureCollection',
  crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
  features: [
    // Primary Nodes
    { type: 'Feature', properties: { site_name: 'Oregon Slope Base', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-125.398241666666706, 44.509568333333327, -2900.0] } },
    { type: 'Feature', properties: { site_name: 'Southern Hydrate Ridge', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-125.148328333333296, 44.481441666666669, -1242.0] } },
    { type: 'Feature', properties: { site_name: 'Oregon Offshore', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-124.961983333333293, 44.36365, -615.0] } },
    { type: 'Feature', properties: { site_name: 'Oregon Shelf', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-124.457011666666702, 44.691385, -113.0] } },
    { type: 'Feature', properties: { site_name: 'Axial Base', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-129.743155, 45.820455, -2611.0] } },
    { type: 'Feature', properties: { site_name: 'Axial Caldera', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-129.969737, 45.941273, -1530.0] } },
    { type: 'Feature', properties: { site_name: 'Mid-Plate', region: 'RSN' }, geometry: { type: 'Point', coordinates: [-127.278438333333298, 45.755555, -2850.0] } },
  ],
};
// --------------------------------------------------------------------------

const CityLabels = {
  type: 'FeatureCollection',
  crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
  features: [
    { type: 'Feature', properties: { city_name: 'Portland', region: 'Oregon' }, geometry: { type: 'Point', coordinates: [-122.8844207, 45.5550397] } },
    { type: 'Feature', properties: { city_name: 'Salem', region: 'Oregon' }, geometry: { type: 'Point', coordinates: [-123.098247, 44.9330916] } },
    { type: 'Feature', properties: { city_name: 'Eugene', region: 'Oregon' }, geometry: { type: 'Point', coordinates: [-123.1925901, 44.0607674] } },
    { type: 'Feature', properties: { city_name: 'Pacific City', region: 'Oregon' }, geometry: { type: 'Point', coordinates: [-123.96715, 45.2023] } },
    { type: 'Feature', properties: { city_name: 'Seattle', region: 'Washington' }, geometry: { type: 'Point', coordinates: [-122.2921467, 47.6131746] } },
    { type: 'Feature', properties: { city_name: 'Olympia', region: 'Washington' }, geometry: { type: 'Point', coordinates: [-122.9288879, 47.0393866] } },
    { type: 'Feature', properties: { city_name: 'Vancouver B.C.', region: 'Canada' }, geometry: { type: 'Point', coordinates: [-123.1939434, 49.2578263] } },

  ],
};
// -------------------------------------------------------------------------

// "map_icon_mapping": "anchor"
const Anchors = {
  type: 'FeatureCollection',
  crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
  features: [
    { type: 'Feature', properties: { name: 'PC01A_EOM_Anch', map_icon_mapping: 'anchor' }, geometry: { type: 'Point', coordinates: [-125.389559789605002, 44.515591061878361, -2904.33333333333394] } },
    { type: 'Feature', properties: { name: 'PC01A_MechAnch', map_icon_mapping: 'anchor' }, geometry: { type: 'Point', coordinates: [-125.389128510391899, 44.543131479946403, -2898.0] } },
    { type: 'Feature', properties: { name: 'PC03A_EOM_Anch', map_icon_mapping: 'anchor' }, geometry: { type: 'Point', coordinates: [-129.753548, 45.817697, -2607.0] } },
    { type: 'Feature', properties: { name: 'PC03A_MechAnch', map_icon_mapping: 'anchor' }, geometry: { type: 'Point', coordinates: [-129.753002349629298, 45.843414455735839, -2600.0] } },
  ],
};
// -------------------------------------------------------------------------

// Bathymetry Layers used in WebMap.vue ------------------------------------
const bathymetryLayers = [
  // Blue Bathymetries
  {
    name: 'blue-base-bathymetry',
    url: '/basemap-layers/blue-basemap.tif',
    bounds: [-138.648838, 41.07155429619806, -114.74620977151781, 49.58103],
    colorbar: accessibleColorbar,
  },
  {
    name: 'blue-axial-base-bathymetry',
    url: '/basemap-layers/blue-axial-base-bathymetry_cog.tif',
    bounds: [-129.979010272, 45.692434467, -129.525189272, 45.894446786],
    colorbar: axialBaseAccessibleColorbar,
  },
  {
    name: 'blue-axial-caldera-bathymetry',
    url: '/basemap-layers/blue-axial-caldera-bathymetry_cog.tif',
    bounds: [-130.054993552, 45.858343933, -129.956663085, 46.016663509],
    colorbar: axialCalderaAccessibleColorbar,
  },
  {
    name: 'blue-hydrate-bathymetry',
    url: '/basemap-layers/blue-hydrate-bathymetry_cog.tif',
    bounds: [-126.004119946, 44.16664031111051, -123.937042163, 45.03335455088949],
    colorbar: oregonShelfSlopeAccessibleColorbar,
  },
  {
    name: 'blue-washington-offshore-bathymetry',
    url: '/basemap-layers/blue-washington-offshore-bathymetry_cog.tif',
    bounds: [-125.379547244, 46.679029858, -124.174896115, 47.164883163],
    colorbar: waOffshoreAccessibleColorbar,
  },
  // Regular Bathymetries
  {
    name: 'base-bathymetry',
    url: '/basemap-layers/base-bathymetry_cog.tif',
    bounds: [-139.249761283, 39.89352562799991, -120.94230622899997, 51.077956818],
    colorbar: standardColorbar,
  },
  {
    name: 'hydrate-bathymetry',
    url: '/basemap-layers/hydrate-bathymetry_cog.tif',
    bounds: [-126.004119946, 44.166249018, -123.93759162546226, 45.03296325777898],
    colorbar: oregonShelfSlopeColorbar,
  },
  {
    name: 'axial-bathymetry',
    url: '/basemap-layers/axial-bathymetry_cog.tif',
    bounds: [-129.979010272, 45.692434467, -129.525189272, 45.894446786],
    colorbar: axialBaseColorbar,
  },
  {
    name: 'axial-caldera-bathymetry',
    url: '/basemap-layers/axial-caldera_cog.tif',
    bounds: [
      -130.10033435919297,
      45.883701901169935,
      -129.91423345581686,
      46.03637257482215,
    ],
    colorbar: axialCalderaColorbar,
  },
  {
    name: 'washington-offshore-bathymetry',
    url: '/basemap-layers/washington-offshore_cog.tif',
    bounds: [-125.379547244, 46.67978079046523, -124.174896115, 47.164883163],
    colorbar: waOffshoreColorbar,
  },
];
// -------------------------------------------------------------------------

export {
  InitialPolygons,
  InitialLabels,
  SiteLabels,
  CityLabels,
  Anchors,
  ResearchAreaMap,
  instIcons,
  infraIcons,
  bathymetryLayers,
};
